import { isHidden } from "../lib/platforms";
import { Check } from "lucide-react";

// Prompt 23 A — "Which accounting system do you use?" logo tiles.
export const GL_CHOICES = [
  { erp: "quickbooks", name: "QuickBooks Online", mark: "qb", bg: "#2CA01C" },
  { erp: "xero", name: "Xero", mark: "xero", bg: "#13B5EA" },
  { erp: "zoho", name: "Zoho Books", mark: "zoho", bg: "#E42527" },
  { erp: "bc", name: "Microsoft Dynamics 365 Business Central", mark: "BC", bg: "#0B556A" },
  { erp: "freshbooks", name: "FreshBooks", mark: "fb", bg: "#0075DD" },
  { erp: "odoo", name: "Odoo", mark: "odoo", bg: "#714B67" },
];

export const glName = (erp) => (GL_CHOICES.find((g) => g.erp === erp) || {}).name || erp;

export function GlLogo({ g, size = 44 }) {
  return (
    <div className="shrink-0 rounded-md flex items-center justify-center text-white font-display font-bold lowercase tracking-tight"
         style={{ background: g.bg, width: size, height: size, fontSize: g.mark.length > 2 ? 12 : 16 }}
         aria-hidden="true">
      {g.mark}
    </div>
  );
}

export function GlChoiceGrid({ selected, onSelect, disabled }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-testid="gl-choice-grid">
      {GL_CHOICES.filter((g) => !isHidden(g.erp)).map((g) => {
        const active = selected === g.erp;
        return (
          <button key={g.erp} type="button" disabled={disabled}
                  onClick={() => onSelect(g.erp)}
                  className={`flex items-center gap-3 border p-3 text-left transition-colors duration-150 ${
                    active ? "border-neutral-900 bg-neutral-50" : "border-neutral-200 hover:border-neutral-900"}`}
                  data-testid={`gl-choice-${g.erp}`} data-selected={active ? "true" : "false"}>
            <GlLogo g={g} />
            <span className="flex-1 text-sm font-medium leading-snug">{g.name}</span>
            {active ? <Check size={16} /> : null}
          </button>
        );
      })}
    </div>
  );
}
